import i18next from 'i18next';
import moment from 'moment-timezone';
import React, { useEffect } from 'react';

import {
  GENERIC_MODAL_CANCEL_BUTTON,
  GENERIC_MODAL_EXPORT_BUTTON,
} from '@commons/Modals/GenericModal/genericModalActions';

import { usePeriodDatePickerState } from '@hooks/usePeriodDatePickerState';
import ExportModalWithStoresAndPeriod from '@commons/ExportModalWithStoresAndPeriod';

import { ExportModalContainer } from '../../styledComponents';

export const LossesExportModalContent = ({
  clientStoreName,
  defaultTimezone,
  stores,
  groups,
  selectedGroups,
  selectedStoresForExport,
  setSelectedGroups,
  setSelectedStoresForExport,
  setExportPeriod,
}) => {
  const periodPickerState = usePeriodDatePickerState(moment(), moment(), defaultTimezone);

  useEffect(() => {
    if (!periodPickerState.startDate || !periodPickerState.endDate) {
      return;
    }

    setExportPeriod({ startDate: periodPickerState.startDate, endDate: periodPickerState.endDate });
  }, [periodPickerState.startDate, periodPickerState.endDate]);

  return (
    <ExportModalContainer>
      <ExportModalWithStoresAndPeriod
        clientStoreName={clientStoreName}
        defaultTimezone={defaultTimezone}
        filteredStores={stores}
        groups={groups}
        maxFutureDate={moment()}
        periodPickerState={periodPickerState}
        selectedGroups={selectedGroups}
        selectedStores={selectedStoresForExport}
        setSelectedGroups={setSelectedGroups}
        setSelectedStores={setSelectedStoresForExport}
      />
    </ExportModalContainer>
  );
};

export const getExportModalConfig = ({
  clientStoreName,
  defaultTimezone,
  stores,
  groups,
  selectedGroups,
  selectedStoresForExport,
  setSelectedGroups,
  setSelectedStoresForExport,
  exportPeriod,
  setExportPeriod,
  handleCloseCleanUp,
  handleExport,
}) => ({
  type: 'action',
  width: '542px',
  height: 'auto',
  maxHeight: '560px',
  icon: '/images/inpulse/link-black-small.svg',
  title: i18next.t('LOSSES.LIST.EXPORT_MODAL_TITLE'),
  component: LossesExportModalContent,
  handleCloseCleanUp,
  data: {
    clientStoreName,
    defaultTimezone,
    stores,
    groups,
    selectedGroups,
    selectedStoresForExport,
    setSelectedGroups,
    setSelectedStoresForExport,
    setExportPeriod,
  },
  actions: [
    GENERIC_MODAL_CANCEL_BUTTON(),
    {
      ...GENERIC_MODAL_EXPORT_BUTTON(),
      isDisabled:
        !exportPeriod.startDate || !exportPeriod.endDate || !selectedStoresForExport.length,
      handleClick: handleExport,
    },
  ],
});
